export default __webpack_public_path__ + "static/media/semaforo luz verde.34fd6b36.svg";